// extracted by mini-css-extract-plugin
export default {"wrapper":"AccreditationB_wrapper__dCVy6"};